import Snackbar from "./Snackbar";
import { Store } from "react-notifications-component";

export function errorNotification(title, message = "Something went wrong") {
    sendNotification(message);
}

export async function sendNotification(
    message,
    {
        duration = globalThis.config.notification.duration,
        id = "",
        onRemoval = undefined,
        close,
        action,
        actionProps,
        icon,
        feedbackIcon,
    } = {}
) {
    const notificationId = Store.addNotification({
        id: id,
        content: (
            <Snackbar
                message={message}
                close={close}
                action={action}
                actionProps={actionProps}
                icon={icon}
                feedbackIcon={feedbackIcon}
                onClose={() => {
                    Store.removeNotification(notificationId);
                }}
            />
        ),
        insert: "top",
        container: "bottom-left",
        onRemoval: onRemoval,
        dismiss: {
            duration: duration,
            pauseOnHover: true,
            click: false,
            touch: false,
        },
    });
}
